import { MediaFilmStripListItemSelector } from './filmstripView/index';
export var mediaFilmstripItemDOMSelector = function mediaFilmstripItemDOMSelector(offset) {
  return ".".concat(MediaFilmStripListItemSelector, ":nth-child(").concat(offset, ")");
};